import scrollToElement from 'scroll-to-element';

class ScrollTo {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
	}

	init() {
		let self = this;

		self.elem.addEventListener('click', evt => {
			evt.preventDefault();

			scrollToElement(self.elem.getAttribute("href"), {
				offset: -60,
				duration: 1000
			});
		});
	}
}

export default ScrollTo;